import React from "react";
import { useI18n } from "@/lib/i18n";

// Use a striking portrait photo for the Why section
const WHY_IMG = "/photos/p23.jpg";

export default function Why() {
  const { t } = useI18n();
  return (
    <section id="about" data-testid="why-section" className="relative bg-charcoal py-24 lg:py-40 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-10">
          {/* Left image */}
          <div className="col-span-12 lg:col-span-5 relative">
            <div className="aspect-[3/4] overflow-hidden hover-zoom bg-onyx">
              <img
                src={WHY_IMG}
                alt="Реставрація мармуру — Джавала"
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 left-6 right-6 lg:-bottom-10 lg:-right-10 lg:left-auto lg:w-72 bg-onyx p-6 border border-bone/10">
              <div className="font-display text-5xl text-brass leading-none">20+</div>
              <div className="text-[0.7rem] tracking-[0.2em] uppercase text-taupe mt-2">Років досвіду</div>
            </div>
          </div>

          {/* Right list */}
          <div className="col-span-12 lg:col-span-6 lg:col-start-7">
            <div className="eyebrow mb-6 flex items-center gap-3">
              <span className="w-8 h-px bg-brass" /> {t.why.eyebrow}
            </div>
            <h2 className="font-display text-[2.4rem] sm:text-5xl lg:text-6xl text-bone leading-[1] tracking-tight mb-12">
              {t.why.title_1} <span className="italic-display text-brass">{t.why.title_2}</span>
            </h2>
            <div className="divide-y divide-bone/8">
              {t.why.list.map((w, i) => (
                <div key={i} data-testid={`why-item-${i}`} className="grid grid-cols-12 gap-6 py-8 group">
                  <div className="col-span-2 font-display text-2xl text-brass leading-none pt-1">0{i + 1}</div>
                  <div className="col-span-10">
                    <h3 className="font-display text-2xl lg:text-3xl text-bone tracking-tight group-hover:text-brass transition-colors duration-500">{w.t}</h3>
                    <p className="mt-3 text-bone/65 leading-relaxed text-[0.95rem] max-w-lg">{w.d}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
